import React from 'react'
import styles from './Code.css'
import { UnControlled as CodeMirror } from 'react-codemirror2'
import jsHighlight from "codemirror/mode/javascript/javascript"
import xmlHighlight from "codemirror/mode/xml/xml"
import jsxHighlight from "codemirror/mode/jsx/jsx"
import { formatCode, prefixCode } from './utils'

/* eslint-disable */
export default class Code extends React.Component {
  render () {
    const { code, name, onChange, editorDidMount } = this.props
    const formattedCode = formatCode(code)
    const displayCode = prefixCode(name, formattedCode)
    return (
        <CodeMirror
          value={displayCode}
          options={{
            mode: 'text/jsx',
            theme: 'material',
            lineNumbers: false,
            lineWrapping: true,
            matchBrackets: true,
            smartIndent: false,
            dragDrop: false,
            tabSize: 2,
            scrollbarStyle: null,
            viewportMargin: Infinity,
          }}
          editorDidMount={editorDidMount}
          onChange={onChange}
        />

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Code/Code.js